import NeighborhoodPage from "@/components/NeighborhoodPage";
import heroImage from "@/assets/hero-ipanema.jpg?w=640;1024;1600;1920&format=avif;webp;jpg&as=picture";

const Ipanema = () => (
  <NeighborhoodPage
    name="Ipanema"
    slug="ipanema"
    description="Charme, sofisticação e uma das praias mais famosas do planeta. Imóveis de alto padrão em localização privilegiada na Zona Sul."
    heroPicture={heroImage}
  />
);

export default Ipanema;
